import { Link, Message, Stack, Text } from "basis";
import { AccountWithPersonalDetails } from "pages/ManagePersonalDetails/types";

interface Props {
  canEdit: boolean;
  email: string;
  accountWithPersonalDetails: AccountWithPersonalDetails;
}

export const Email = ({
  canEdit,
  email,
  accountWithPersonalDetails: { account, personalDetails },
}: Props) => (
  <Stack gap="5">
    <Text as="h3" textStyle="heading5" color="primary.blue.t100">
      Email address
    </Text>
    <Text>{email || "This account doesn't have an email address."}</Text>
    {canEdit && (
      <Stack gap="5">
        <Link
          href="/manage-personal-details/update-email"
          newTab={false}
          state={{ account, fullPersonalDetails: personalDetails }}
        >
          {email ? "Edit" : "Add"}
        </Link>
        <Message
          testId="email-message"
          severity="info-or-minor"
          bg="secondary.lightBlue.t25"
        >
          This is your contact email. It may be different from your Latitude ID
          (the email used to log onto your app or LSC).
        </Message>
      </Stack>
    )}
  </Stack>
);
